export default {
      id: "cscs-card-usage",
      viewBox: "0 0 130 85",
      url: __webpack_public_path__ + "sprite.svg#cscs-card",
      toString: function () {
        return this.url;
      }
    }